var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useShopConfig } from '@jetshop/core/hooks/useShopConfig';
import React, { useEffect } from 'react';
import { useApolloClient } from 'react-apollo';
import { useHistory } from 'react-router';
import { getActiveFiltersFromSearch } from '../../resolvers/filters/filterParams';
import { StructuredCategoryData } from '../StructuredData';
function useFiltersOnHistoryPop() {
    const client = useApolloClient();
    useEffect(() => {
        function getSearchFilters() {
            // Write the active filters from search
            client.writeData({
                data: {
                    activeFilters: getActiveFiltersFromSearch(window.location.search)
                }
            });
        }
        window.addEventListener('popstate', getSearchFilters);
        return () => window.removeEventListener('popstate', getSearchFilters);
    }, [client]);
}
const CategoryRoute = (props) => {
    var _a, _b, _c;
    const { component: CategoryPage } = props, rest = __rest(props, ["component"]);
    const category = ((_b = (_a = props.result.data) === null || _a === void 0 ? void 0 : _a.route) === null || _b === void 0 ? void 0 : _b.object) || ((_c = props.result.data) === null || _c === void 0 ? void 0 : _c.category);
    const { structuredData } = useShopConfig();
    const disableDefaultCategoryData = structuredData
        ? !!structuredData.disableDefaultCategoryData
        : false;
    const history = useHistory();
    useFiltersOnHistoryPop();
    useEffect(() => {
        var _a;
        if ((category === null || category === void 0 ? void 0 : category.name.length) > 0 && !((_a = history.location.state) === null || _a === void 0 ? void 0 : _a.list)) {
            history.replace(history.location.pathname +
                history.location.search +
                history.location.hash, Object.assign({ list: category.name }, history.location.state));
        }
    }, [category, history]);
    return (React.createElement(React.Fragment, null,
        category && (React.createElement(React.Fragment, null, !disableDefaultCategoryData && (React.createElement(StructuredCategoryData, { category: category })))),
        React.createElement(CategoryPage, Object.assign({}, rest, { category: category }))));
};
export default CategoryRoute;
//# sourceMappingURL=CategoryRoute.js.map